export const DeleteOption = {
    Me: "0",
    Other: "1",
};

export const GuestOption = {
    Users: "0",
    Guests: "1",
    Both: "2",
};